module.exports = __webpack_public_path__ + "img/wlv_20.bfd05fdf.png";